import LoadingAll from "@/components/LoadingAll";

const Loading = () => {
    return <LoadingAll />;
};

export default Loading;
